import dayjs, { Dayjs } from 'dayjs'

const ONE_MONTH = 30

const toDayjs = (date: string | number | Date | Dayjs): Dayjs => dayjs(date)

const isWithinPastDays =
  (days: number) =>
  (date: string | number | Date | Dayjs): boolean => {
    const parsedDate = toDayjs(date)
    const today = dayjs()

    if (!parsedDate.isValid() || parsedDate.isAfter(today)) {
      return false
    }

    return parsedDate.isAfter(today.subtract(days, 'day'))
  }

export const isWithinPastOneMonth = isWithinPastDays(ONE_MONTH)
